/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AnswersControllerFindAllQueryResponse, AnswersControllerFindAllQueryParams, AnswersControllerFindAll401, AnswersControllerFindAll403 } from "../../models/checklistsController/AnswersControllerFindAll";

function getAnswersControllerFindAllUrl() {
  const res = { method: 'GET', url: `/api/v1/checklist-answers` as const }  
  return res
}

/**
 * @description This endpoint supports a higher page size limit of 1000 (default is 100). Use `page[size]=1000` to retrieve up to 1000 records per request.
 * @summary Get all checklist answers
 * {@link /api/v1/checklist-answers}
 */
export async function answersControllerFindAll(params?: AnswersControllerFindAllQueryParams, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<AnswersControllerFindAllQueryResponse, ResponseErrorConfig<AnswersControllerFindAll401 | AnswersControllerFindAll403>, unknown>({ method : "GET", url : getAnswersControllerFindAllUrl().url.toString(), params, ... requestConfig })  
  return res.data
}